"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _policyAdminService = require("../../../services/policy-admin-service");

var _actions = require("./actions");

var _constant = require("./constant");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(permissionsConsumerListWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getConsumerListWorker);

function permissionsConsumerListWatcher() {
  return regeneratorRuntime.wrap(function permissionsConsumerListWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constant.ConsumerListTypes.CONSUMER_LIST_REQUEST, getConsumerListWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function getConsumerListWorker() {
  var consumerList, _response$data, response, reason;

  return regeneratorRuntime.wrap(function getConsumerListWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _actions.consumerListLoading)());

        case 2:
          _context2.prev = 2;
          _context2.next = 5;
          return (0, _effects.call)(_policyAdminService.getConsumerList);

        case 5:
          consumerList = _context2.sent;
          _context2.next = 8;
          return (0, _effects.put)((0, _actions.consumerListSuccess)(consumerList));

        case 8:
          _context2.next = 16;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          response = _context2.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context2.next = 16;
          return (0, _effects.put)((0, _actions.consumerListFailure)({
            error: reason
          }));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[2, 10]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(permissionsConsumerListWatcher)]);

exports.default = _default;